import request from '@/utils/request'

let Insurance_coverage_periodApi = {

  /*投保时间列表*/
  list(data) {
    return request._post('/shop/plus.insurance_coverage_period.Index/index', data);
},
/*添加投保时间*/
add(data) {
    return request._post('/shop/plus.insurance_coverage_period.Index/add', data);
},
/*修改投保时间*/
edit(data) {
    return request._post('/shop/plus.insurance_coverage_period.Index/edit', data);
},
/*删除投保时间*/
del(data) {
    return request._post('/shop/plus.insurance_coverage_period.Index/del', data);
},
/*投保时间详情*/
detail(data) {
  return request._post('/shop/plus.insurance_coverage_period.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.insurance_coverage_period.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.insurance_coverage_period.Setting/getSetting', data, errorback);
    },
}
export default Insurance_coverage_periodApi;



// WEBPACK FOOTER //
// ./src/api/insurance_coverage_period.js